import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinpune() {



  const cardData =
  {
    keyword: 'Tempo Traveller on Rent in Pune',
    heading: 'Sai Trupti Cabs: Tempo Traveller on Rent in Pune',
    headingDescription: 'Tempo Traveller on rent in Pune with Sai Trupti Cabs offers reliable and comfortable group-travel solutions for local outings, weddings, corporate trips, or outstation tours. Our fleet includes well-maintained, air-conditioned vehicles in various seating capacities (9-seater, 13-seater, 17-seater and more) — all equipped with spacious interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup anywhere in Pune, courteous service, and safe, smooth driving throughout your trip. With transparent rental fares (per km or day-package), flexible booking options (one-way, round-trip, local or outstation), and 24 × 7 customer support, Sai Trupti Cabs makes your Tempo Traveller hire in Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
  {
    "name": "Tempo Traveller on Rent in Pune",
    "description": "Rent a Tempo Traveller in Pune for local and outstation trips with spacious seating, AC/non-AC options, professional drivers, luggage support, and flexible pickup/drop timings. Ideal for large families, group tours, school trips, weddings, and corporate outings, ensuring a smooth and enjoyable travel experience with reliable service and transparent fares."
  },
  {
    "name": "Pune Tempo Traveller Hire",
    "description": "Reliable Tempo Traveller hire service in Pune offering 12, 16, 19, and 22-seater options with AC/non-AC facilities. Enjoy comfortable seating, professional drivers, clean interiors, ample luggage space, and flexible schedules, perfect for family functions, business events, and long-distance travel."
  },
  {
    "name": "AC Tempo Traveller Pune",
    "description": "Book an AC Tempo Traveller in Pune for cool, comfortable, and relaxed group travel. Equipped with luxury pushback seats, AC vents for every passenger, and professional chauffeurs, this service is ideal for corporate tours, weddings, and family vacations with smooth rides and punctual service."
  },
  {
    "name": "Non AC Tempo Traveller Pune",
    "description": "Affordable non-AC Tempo Traveller rental in Pune offering a budget-friendly option for group travel. Perfect for short-distance trips, school excursions, pilgrimages, and events, with reliable drivers, clean seating arrangements, and transparent fares for comfortable journeys."
  },
  {
    "name": "Luxury Tempo Traveller Pune",
    "description": "Experience premium group travel with luxury Tempo Traveller hire in Pune. Enjoy plush seating, music systems, ambient lighting, professional chauffeurs, and on-time service. Ideal for weddings, corporate events, VIP guests, or luxury road trips to outstation destinations like Lonavala, Mahabaleshwar, and Goa."
  },
  {
    "name": "Tempo Traveller for Wedding Pune",
    "description": "Rent a Tempo Traveller in Pune for wedding travel, offering spacious and elegant interiors with AC/non-AC options. Perfect for transporting guests comfortably to and from venues, with punctual service, courteous drivers, and flexible scheduling for smooth wedding logistics."
  },
  {
    "name": "Tempo Traveller for Corporate Trips Pune",
    "description": "Corporate Tempo Traveller hire in Pune designed for business groups and events. Enjoy spacious seating, AC comfort, professional chauffeurs, flexible timings, and safe travel. Ideal for office trips, conferences, factory visits, and corporate events with reliable service and transparent billing."
  },
  {
    "name": "Outstation Tempo Traveller Pune",
    "description": "Outstation Tempo Traveller rental service from Pune offering safe, spacious, and comfortable group travel for destinations like Mumbai, Shirdi, Mahabaleshwar, Lonavala, and beyond. Choose from 12, 16, 19, or 22-seater models with AC/non-AC options, ample luggage space, and experienced drivers."
  },
  {
    "name": "Affordable Tempo Traveller Rental Pune",
    "description": "Budget-friendly Tempo Traveller hire in Pune with affordable pricing, transparent fares, and reliable service. Perfect for family tours, religious trips, and corporate travel, ensuring safe and comfortable journeys with professional drivers and clean, well-maintained vehicles."
  },
  {
    "name": "Tempo Traveller Online Booking Pune",
    "description": "Book a Tempo Traveller online in Pune instantly with secure payment options, flexible seating capacities, AC/non-AC variants, and professional drivers. Easy online booking for one-way, round trips, or outstation travel with live support and transparent pricing."
  },
  {
    "name": "Tempo Traveller Hire Near Me Pune",
    "description": "Find Tempo Traveller rental near your location in Pune with quick booking, multiple seating options, AC/non-AC facilities, professional chauffeurs, and affordable rates. Convenient for local tours, weddings, and corporate travel with 24x7 availability."
  },
  {
    "name": "Tempo Traveller for Family Trip Pune",
    "description": "Rent a Tempo Traveller in Pune for family trips with spacious interiors, pushback seats, AC comfort, ample luggage space, and professional drivers. Perfect for vacations, picnics, and pilgrimages, ensuring a safe, fun, and comfortable journey for all members."
  },
  {
    "name": "Best Tempo Traveller Rental Pune",
    "description": "Top-rated Tempo Traveller rental service in Pune offering a fleet of well-maintained vehicles, AC/non-AC variants, professional drivers, flexible schedules, and transparent fares. Ideal for group travel, weddings, and outstation trips ensuring comfort and reliability."
  },
  {
    "name": "Pune 12/16/19/22 Seater Tempo Traveller",
    "description": "Hire 12, 16, 19, or 22-seater Tempo Travellers in Pune for group tours, school trips, weddings, or business outings. Each vehicle offers AC/non-AC options, pushback seats, luggage space, professional drivers, and safe, convenient travel for large groups."
  },
  {
    "name": "Tempo Traveller Service 24x7 Pune",
    "description": "24x7 Tempo Traveller rental service in Pune providing round-the-clock support for bookings, pickups, and emergencies. Ideal for sudden travel plans, corporate needs, and family outings with reliable vehicles, professional chauffeurs, and on-time service every time."
  }
],
"tableData": [
  ["Tempo Traveller on Rent in Pune", "Pune Tempo Traveller Hire"],
  ["AC Tempo Traveller Pune", "Non AC Tempo Traveller Pune"],
  ["Luxury Tempo Traveller Pune", "Tempo Traveller for Wedding Pune"],
  ["Tempo Traveller for Corporate Trips Pune", "Outstation Tempo Traveller Pune"],
  ["Affordable Tempo Traveller Rental Pune", "Tempo Traveller Online Booking Pune"],
  ["Tempo Traveller Hire Near Me Pune", "Tempo Traveller for Family Trip Pune"],
  ["Best Tempo Traveller Rental Pune", "Pune 12/16/19/22 Seater Tempo Traveller"],
  ["Tempo Traveller Service 24x7 Pune", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Tempo Traveller on Rent in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd provides spacious and reliable Tempo Traveller rentals in Pune—ideal for group outings, corporate events, family trips or multi‑day travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Pricing",
    "WhyChoosedescription": "Our Tempo Traveller rates in Pune start at approximately ₹20–₹25 per km for 9‑12 seaters, and ₹28–₹34 per km for 20+ seater vehicles. :contentReference[oaicite:turn0search0]{index=1} :contentReference[oaicite:turn0search3]{index=1}"
  },
  {
    "WhyChooseheading": "Large Seating Capacity Options",
    "WhyChoosedescription": "We offer a wide range of Tempo Travellers—from 9, 12, 13, 14 up to 22/26‑seaters—suitable for school trips, weddings, corporate tours or large family excursions. :contentReference[oaicite:turn0search4]{index=2}"
  },
  {
    "WhyChooseheading": "Well‑Maintained Vehicles with Comfort Features",
    "WhyChoosedescription": "All our Tempo Travellers are air‑conditioned, regularly serviced, have ample luggage space and are equipped for longer journeys in comfort. :contentReference[oaicite:turn0search8]{index=3}"
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our drivers are trained, courteous and familiar with inter‑city and group travel logistics—ensuring a safe, smooth and timely trip from Pune or beyond."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Whether you need local full‑day, short trip or outstation multi‑day hire, we offer customizable packages including driver allowance, km limits, and extra‑km options."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, logistics changes or travel assistance for your Tempo Traveller rental."
  },
  {
    "WhyChooseheading": "Easy Booking Process",
    "WhyChoosedescription": "Book your Tempo Traveller in Pune simply via call, WhatsApp or our website—select date, seats, km‑limit and we’ll provide confirmation and dispatch promptly."
  }
]


















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer tempo‑traveller on rent in Pune?',
    answer: 'Yes, Sai Trupti Cabs  offers spacious tempo‑traveller vehicles on rent in Pune for group travel, corporate trips, outings, and outstation journeys.',
  },
  {
    question: 'How can I book a tempo‑traveller on rent in Pune with Sai Trupti Cabs?',
    answer: 'You can easily book your tempo‑traveller rental in Pune through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What seating capacities are available for tempo‑traveller rentals in Pune?',
    answer: 'We provide multiple seating options including 9‑seater, 12‑seater, 15/17‑seater, 20/22‑seater tempo‑travellers to suit your group size and travel requirements.',
  },
  {
    question: 'Are the drivers experienced for tempo‑traveller rentals in Pune?',
    answer: 'Yes, all our drivers are professional, courteous and experienced in group / outstation transportation, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Is the tempo‑traveller rental service in Pune available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 tempo‑traveller rental services in Pune for your convenience and flexible scheduling.',
  },
  {
    question: 'What are the typical rental rates for tempo‑traveller in Pune?',
    answer: 'Rental rates for tempo‑traveller in Pune start from approximately ₹ 21–₹ 25 per km depending on seating capacity and vehicle category, with daily packages starting around ₹ 2,500–₹ 4,500 for local trips and higher for outstation usage. :contentReference[oaicite:1]{index=1}',
  },
  {
    question: 'What payment methods are accepted for tempo‑traveller rentals in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for smooth and hassle‑free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for tempo‑traveller rentals in Pune?',
    answer: 'All our tempo‑traveller vehicles are well maintained, sanitized before every trip and driven by trained professional drivers to ensure a safe and comfortable journey.',
  },
  {
    question: 'Is customer support available during the tempo‑traveller rental period in Pune?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you throughout your tempo‑traveller rental period in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'We rented a tempo‑traveller in Pune from Sai Trupti Cabs for our group outing and the experience was terrific. Comfortable seats and very punctual driver.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Patwardhan',
    feedback: 'The tempo‑traveller rental with Sai Trupti Cabs was exactly what we needed for our family event. Good vehicle, driver was courteous, and trip was hassle‑free.',
    rating: 5,
  },
];



















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent in Pune",
  "image": "https://saitrupticabs.com/assets/images/tempo-traveller-pune.jpg",
  "description": "Rent a Tempo Traveller in Pune for weddings, corporate trips, family trips, or outstation travel. Available in AC and Non-AC options with 12/16/19/22-seater capacity. Affordable and available for 24x7 booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7520"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/tempo-traveller-on-rent-pune"
  }
};









  return (
    <div>
      <Helmet>
  <title>Tempo Traveller on Rent in Pune | AC & Non-AC | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Rent a Tempo Traveller in Pune for weddings, corporate trips, family trips, or outstation travel. Available in AC and Non-AC options with 12/16/19/22-seater capacity. Affordable and available for 24x7 booking." 
  />
  <meta 
    name="keywords" 
    content="Tempo Traveller on Rent in Pune, Pune Tempo Traveller Hire, AC Tempo Traveller Pune, Non AC Tempo Traveller Pune, Luxury Tempo Traveller Pune, Tempo Traveller for Wedding Pune, Tempo Traveller for Corporate Trips Pune, Outstation Tempo Traveller Pune, Affordable Tempo Traveller Rental Pune, Tempo Traveller Online Booking Pune, Tempo Traveller Hire Near Me Pune, Tempo Traveller for Family Trip Pune, Best Tempo Traveller Rental Pune, Pune 12/16/19/22 Seater Tempo Traveller, Tempo Traveller Service 24x7 Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentinpune;